import { Actor } from "../actors/Actor";
import { gameData } from "../GameManager";
import { Item } from "./Item";

export const pickupItem = (actor: Actor, item: Item) => {
  gameData.items.remove(item.id);
  if (item) {
    const existing = actor.contains.find((i) => i.breed === item.breed);
    if (existing) {
      existing.uses += 1;
    } else {
      actor.contains.add(item.id, item);
    }
    return { valid: true };
  }
  return { valid: false };
};
